import './style.scss';
import './pagination.scss';
import React from 'react';
import { isServer } from '@sitecore-jss/sitecore-jss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Pagination, Navigation } from 'swiper';
import Item from './Item';
const CardItemsCarousel = (props) => {
  const { language, items, setPrevDisabled, setNextDisabled, swiperRef } = props;

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="custom-pagination-cardlisting ' + className + '"></span>';
    },
  };
  const onSwap = (pagesAmount, isFirst, isLast) => {
    setPrevDisabled(isFirst);
    setNextDisabled(isLast);
  };

  const handleSwap = (swiper) => {
    if (!onSwap) return;
    if (swiper?.pagination?.bullets?.length) {
      onSwap(swiper?.pagination?.bullets?.length, swiper?.isBeginning, swiper?.isEnd);
    } else {
      onSwap(1, true, true);
    }
  };

  return (
    !isServer() && (
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={pagination}
        dir={language === 'en' ? 'ltr' : 'rtl'}
        spaceBetween={32}
        slidesPerView={4}
        slidesPerGroup={4}
        onSlideChange={handleSwap}
        onPaginationRender={handleSwap}
        ref={swiperRef}
        breakpoints={{
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            freeMode: true,
            spaceBetween: 8,
          },
          375: {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            freeMode: true,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 32,
          },
        }}
      >
        {items?.map((item, index) => {
          return (
            <SwiperSlide className="card-item" key={index}>
              <Item item={item} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  );
};

export default CardItemsCarousel;
